import forEach from 'lodash/forEach'
import uniqBy from 'lodash/uniqBy'
import React, { useContext, useMemo } from 'react'

import { BlockTypeWithGlobal } from '@Generated/graphql'
import { BlockContext, useBlockConfig } from '@Globals/CMS/Context'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { AnchorItemInjection, GridItemInjection } from '@Globals/Injections/Types'
import { MetadataContext } from '@Globals/Metadata'

import styles from './injections.module.scss'

export const Content = ({
  blocks,
  className,
  idPrefix,
  style,
}: {
  blocks: GridItemInjection['blocks']
  className?: string
  idPrefix: string
  style?: React.CSSProperties
}) => {
  const components = useBlockComponents((blocks || []) as BlockTypeWithGlobal[], idPrefix, true, undefined, true)

  if (components && components.length !== 0) {
    return (
      <div className={className} style={style}>{components}</div>
    )
  }

  return null
}

export const AnchorItemInjections = ({ anchor }: { anchor: string }) => {
  const {
    blockID,
    blockType,
  } = useContext(BlockContext)
  const { anchorInjections } = useBlockConfig()
  const items = useMemo(() => {
    const result: AnchorItemInjection[] = []

    forEach(anchorInjections, (injection) => {
      // TODO: think about split testing, maybe it was set up on the wrong level, and should be moved to each injection instead
      forEach(injection.items, (item) => {
        if (item.__typename === 'InjectionTypeAnchor') {
          if (!item.id || !item.anchor || item.anchor !== anchor) {
            return
          }

          result.push(item)
          return
        }
      })
    })

    return uniqBy(result, 'id')
  }, [anchor, anchorInjections])

  if (!items || items.length === 0) {
    return null
  }

  return (
    <>
      {items.map(item => (
        <Content key={item.id!} blocks={item.blocks} className={styles.injectionsWrapper} idPrefix={`${blockType}-${blockID}-ai-${item.id}`} />
      ))}
    </>
  )
}

export const GlobalAnchorItemInjections = ({ anchor }: { anchor: string }) => {
  const { globalAnchorInjections } = useContext(MetadataContext)
  const items = useMemo(() => {
    const result: AnchorItemInjection[] = []

    forEach(globalAnchorInjections?.[anchor], (injection) => {
      // TODO: think about split testing, maybe it was set up on the wrong level, and should be moved to each injection instead
      forEach(injection.items, (item) => {
        if (item.__typename === 'InjectionTypeAnchor') {
          if (!item.id || !item.anchor || item.anchor !== anchor) {
            return
          }

          result.push(item)
          return
        }
      })
    })

    return uniqBy(result, 'id')
  }, [anchor, globalAnchorInjections])

  if (!items || items.length === 0) {
    return null
  }

  return (
    <>
      {items.map(item => (
        <Content key={item.id!} blocks={item.blocks} className={styles.injectionsWrapper} idPrefix={`global-ai-${item.id}`} />
      ))}
    </>
  )
}
